// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1xoDX","filesListContainer":"PosDisputesFiles_filesListContainer__3SYKE","filesButton":"PosDisputesFiles_filesButton__1k2Z7"};